import type {ValidationError} from 'yup';
import type {FakeError, IWrapperProvider} from './types';

export function parseFieldErrors(
  tag: string,
  errors: FakeError | undefined,
  showErrors: IWrapperProvider[`showErrors`],
): [boolean | undefined, string | undefined] {
  const selfError =
    errors &&
    errors.internals &&
    errors.internals[tag] &&
    (errors.internals[tag]!.self as ValidationError);

  const parentError = (errors && errors.self) as ValidationError | undefined;
  const errorMessage =
    showErrors === true && selfError?.message ? selfError?.message : undefined;
  const isInvalid = !!showErrors && (!!errorMessage || !!parentError);
  return [isInvalid, errorMessage];
}
